import { useNavigate } from '@tanstack/react-router'
import type { UrgentDeadline } from '../types'
import styles from './UrgencyBanner.module.css'

type UrgencyBannerProps = {
  deadline: UrgentDeadline
}

const SPORT_ICONS: Record<string, string> = {
  FOOTBALL: '⚽',
  CS2:      '🎮',
}

const SPORT_LABELS: Record<string, string> = {
  FOOTBALL: 'Futebol',
  CS2:      'CS2',
}

export function UrgencyBanner({ deadline }: UrgencyBannerProps) {
  const navigate = useNavigate()
  const icon  = SPORT_ICONS[deadline.competitionSport] ?? '🏆'
  const label = SPORT_LABELS[deadline.competitionSport] ?? deadline.competitionSport

  const countdownText = deadline.hoursLeft > 0
    ? `${deadline.hoursLeft}h ${deadline.minutesLeft}min`
    : `${deadline.minutesLeft}min`

  function handleCta() {
    // Single pending league → go straight to its escalação. Multiple → let the
    // user pick which one on the leagues page.
    if (deadline.pendingSquadCount > 1) {
      void navigate({ to: '/ligas' })
      return
    }
    void navigate({
      to: '/league/$leagueId',
      params: { leagueId: deadline.leagueId },
      search: { tab: 'escalacoes', gw: undefined },
    })
  }

  return (
    <div className={styles.banner}>
      <div className={styles.sportPill}>
        <span className={styles.sportIcon}>{icon}</span>
        <span className={styles.sportLabel}>{label}</span>
      </div>
      <p className={styles.text}>
        <strong>{deadline.competitionName} · Janela bloqueia em {countdownText}</strong>
        {' '}— Finalize sua escalação em &ldquo;{deadline.leagueName}&rdquo;.
      </p>
      <button className={styles.cta} onClick={handleCta} type="button">
        Escalar agora
      </button>
    </div>
  )
}
